import { Route } from "@dashboard/components/Router";
import { sectionNames } from "@dashboard/intl";
import { useIntl } from "react-intl";
import { Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import { importOverviewPath } from "./urls";
import { ImportOverview } from "./views/ImportOverview/ImportOverview";

const ImportSection = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.imports)} />
      <Switch>
        <Route exact path={importOverviewPath} component={ImportOverview} />
      </Switch>
    </>
  );
};

export default ImportSection;
